window.Contacts = {
	prepareFilterForm: function(){
		var options = {success:function(data){Contacts.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("contactsFilterForm", "contacts", options);
	},
	
	processFilterForm: function(data){
		Contacts.buildPagenum(data.contacts_metadatas.pagenum, data.contacts_metadatas.nbPages);
		Listing.refresh("contactsListing", data, data.contacts_metadatas);
	},
	
	buildPagenum: function(pagenum, nbpage){
		
	},
	
	
};